import React from 'react';
import {SortableContainer} from 'react-sortable-hoc';
import SortableCoursesItem from './SortableCoursesItem';
import PropTypes from "prop-types";

const SortableCoursesList = SortableContainer(({items, number, handleChangeVisible, removeAssignedTest}) => {
    return (
        <ul
            key={number}
            className="subject_chapters_list"
        >
            {items.map((value, index) => (
                <SortableCoursesItem
                    key={`item-${index}`}
                    number={number}
                    index={index}
                    value={value}
                    handleChangeVisible={handleChangeVisible}
                    removeAssignedTest={removeAssignedTest}
                />
            ))}
        </ul>
    );
});

SortableCoursesList.propTypes = {
    items: PropTypes.array.isRequired,
    number: PropTypes.number,
    handleChangeVisible: PropTypes.func,
    removeAssignedTest: PropTypes.func
};

export default SortableCoursesList;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableCoursesList.js